import React from 'react';
import PropTypes from 'prop-types';

import { Svg } from './styled-components';

const Icon = ({ icon, width, height, color, viewBoxHeight, viewBoxWidth, ...rest }) => (
  <Svg
    width={width}
    height={height}
    color={color}
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
    {...rest}
  >
    <path d={icon} />
  </Svg>
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
  viewBoxHeight: PropTypes.number,
  viewBoxWidth: PropTypes.number
};

Icon.defaultProps = {
  width: 16,
  height: 16,
  color: '',
  viewBoxHeight: 520,
  viewBoxWidth: 500
};

export default Icon;



// WEBPACK FOOTER //
// ./src/views/common/components/Icon/index.jsx